import SignInPageBase from './SignInPage'

export const SignInPage = SignInPageBase



// WEBPACK FOOTER //
// ./src/routes/SignInPage/index.js